<template>
  <div class="app-single-top-up-wrapper">
    <slot name="txtBefore"></slot>

    <NoPaymentDataView v-if="topUpPossible === false" :url="paymentUrl">
      <template v-for="slot in possibleChildSlotsFor('MissingPayment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </NoPaymentDataView>

    <SingleTopUpSuccessWithPayment
      v-if="showSuccess"
      :payment="singleTopUpStatus_.payment"
    >
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SingleTopUpSuccessWithPayment>

    <GenericAmountInput
      :amounts="singleTopUpStatus_.amounts.amount"
      :default-amount="singleTopUpStatus_.amounts.default"
      :payment="singleTopUpStatus_.payment"
      v-if="showAmountSelector"
      :loading="loadingInit"
      @amount-select="amountSelect"
    >
      <template v-for="slot in possibleChildSlotsFor('Amount')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </GenericAmountInput>

    <SingleTopUpConfirm
      v-if="showPayment"
      :payment="singleTopUpStatus_.payment"
      :payment-type="true"
      :overwrite-formatted-amount="formattedAmount"
      :next-step="'success'"
    >
      <template v-for="slot in possibleChildSlotsFor('Confirm')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SingleTopUpConfirm>

  </div>
</template>
<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'
import { mapGetters, mapMutations } from 'vuex'
import GenericAmountInput from '@/components/process/generic/TopUp/SingleTopUp/GenericAmountInput.vue'
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'
import SingleTopUpConfirm from '@/components/process/generic/TopUp/SingleTopUp/Confirm.vue'
import SingleTopUpSuccessWithPayment from '@/components/process/generic/TopUp/SingleTopUp/SuccessWithPayment.vue'
import NoPaymentDataView from '@/components/process/generic/TopUp/SingleTopUp/NoPaymentDataView.vue'

export default {
  name: 'SingleTopUpWrapper',
  components: { NoPaymentDataView, SingleTopUpSuccessWithPayment, SingleTopUpConfirm, GenericAmountInput },
  mounted () {
    if (this.currentStep === 'success') {
      this.reset()
    }
  },
  data () {
    return {
      loadingInit: false,
      singleTopUpStatus: {
        amounts: {
          amount: [],
          default: null
        },
        payment: {}
      }
    }
  },
  methods: {
    ...mapMutations('topUp/single', [
      'changeStep',
      'reset'
    ]),
    async amountSelect (amount) {
      this.loadingInit = true
      await this.changeStep({ step: 'paymentConfirm', amount })
      this.loadingInit = false
    }
  },
  computed: {
    ...mapGetters('topUp/single', [
      'currentStep',
      'amount'
    ]),
    topUpPossible () {
      return this.singleTopUpStatus_.directPossible
    },
    showAmountSelector () {
      return this.topUpPossible && (this.currentStep === 'amountSelect' || this.currentStep === 'success')
    },
    showPayment () {
      return this.topUpPossible && this.currentStep === 'paymentConfirm'
    },
    showSuccess () {
      return this.topUpPossible && this.currentStep === 'success'
    },
    singleTopUpStatus_: function () {
      return this.singleTopUpStatus
    },
    formattedAmount: function () {
      if (this.amount) {
        return this.price(this.amount)
      }
      return null
    }
  },
  mixins: [
    transaction('singleTopUp'),
    slotProxy(),
    configBasedTopUpPrice
  ],
  apollo: {
    singleTopUpStatus: function () {
      return wrapQuery(
        gql`query singleTopUp {
          singleTopUpStatus {
            directPossible
            amounts {
              amount
            }
            payment {
              ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
            }
          }
        }`, this, 'singleTopUpStatus', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  },
  props: {
    paymentUrl: {
      type: String,
      default: '#'
    }
  }
}
</script>
